// import styled, { css } from 'styled-components';

// export const Container = styled.aside`
//   width: 100%;
//   border-radius: 12px;
//   background: #fff;
//   border: 1px solid #e6e8ef;
//   padding: 16px;
// `;

// export const Header = styled.header`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin-bottom: 14px;
//   color: #263238;

//   strong {
//     font-size: 15px;
//     font-weight: 600;
//   }
// `;

// export const TreeRoot = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
// `;

// export const Group = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// export const GroupButton = styled.button`
//   border: 0;
//   background: transparent;
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   min-height: 34px;
//   padding: 6px 4px;
//   cursor: pointer;
//   font-size: 14px;
//   color: #455a64;
//   text-align: left;

//   &:hover {
//     color: #1565c0;
//   }
// `;

// export const Children = styled.div`
//   margin-left: 14px;
//   padding-left: 10px;
//   border-left: 1px dashed #cfd8dc;
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
// `;

// export const Card = styled.div`
//   border-radius: 10px;
//   border: 1px solid #e1e5ee;
//   background: #fafbff;
//   overflow: hidden;
//   transition: 0.2s ease;

//   a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     flex-direction: column;
//     gap: 10px;
//     min-height: 52px;
//     padding: 10px;
//     color: #263238;
//     text-decoration: none;
//     font-size: 14px;
//     font-weight: 500;
//   }

//   img {
//     width: 210px;
//     height: 210px;
//     border-radius: 8px;
//     object-fit: cover;
//     background: #eceff1;
//     flex-shrink: 0;
//   }

//   &:hover {
//     border-color: #90caf9;
//     background: #f3f8ff;
//     transform: translateY(-1px);
//   }

//   ${({ selected }) =>
//     selected &&
//     css`
//       border-color: #1976d2;
//       background: #eaf4ff;

//       a {
//         color: #0d47a1;
//       }
//     `}
// `;

// export const Empty = styled.div`
//   padding: 12px;
//   border-radius: 8px;
//   background: #f7f8fa;
//   color: #78909c;
//   font-size: 14px;
// `;

import styled, { css } from 'styled-components';

/* ===== Identidade visual (alinhada ao login / Header / TreeView) =====
   --primary: #ff6d3c   --ink: #17263b / #2c405a   --muted: #79869e
   --border: rgba(216, 224, 235, 0.9)

   Antes o componente usava azuis (#1565c0 / #1976d2) fora do padrão da
   aplicação e miniaturas fixas de 210px, que forçavam uma coluna larga.
   Agora as faces são exibidas em grade de 2 colunas, com miniaturas
   fluidas, e o destaque segue o laranja da marca.
==================================================================== */

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #17263b;

  > svg {
    color: #ff6d3c;
  }

  strong {
    font-size: 14px;
    font-weight: 800;
  }
`;

export const TreeRoot = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;

  /** em painéis estreitos volta para coluna única */
  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GroupButton = styled.button`
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 6px 4px;
  cursor: pointer;
  font-size: 13px;
  color: #2c405a;
  text-align: left;

  &:hover {
    color: #ff6d3c;
  }
`;

export const Children = styled.div`
  margin-left: 14px;
  padding-left: 10px;
  border-left: 1px dashed rgba(148, 163, 184, 0.5);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Card = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(216, 224, 235, 0.9);
  background: #fff;
  overflow: hidden;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;

  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    gap: 8px;

    /** 52px garante alvo de toque confortável em tablet */
    min-height: 52px;
    padding: 8px;
    color: #2c405a;
    text-decoration: none;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
  }

  img {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
    object-fit: contain;
    background: #f7fafd;
  }

  &:hover {
    border-color: rgba(255, 109, 60, 0.45);
    background: #fffaf7;
    box-shadow: 0 10px 22px rgba(23, 38, 59, 0.1);
    transform: translateY(-1px);
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: #ff6d3c;
      background: rgba(255, 109, 60, 0.08);
      box-shadow: inset 0 0 0 1px #ff6d3c;

      a {
        color: #17263b;
        font-weight: 800;
      }
    `}
`;

export const Empty = styled.div`
  padding: 12px;
  border-radius: 10px;
  background: rgba(247, 250, 253, 0.9);
  border: 1px dashed rgba(216, 224, 235, 0.9);
  color: #79869e;
  font-size: 13px;
  text-align: center;
`;
